export const sanitizeUsername = (username: string) => {
  return username.replace(/[^a-z0-9_\-@.+]|\s+/gim, '')
}
